import { SupportedLocation } from "./types";

export const CANADA_LOCATIONS: SupportedLocation[] = [
  // ONTARIO
  {
    id: "ca-on-toronto",
    cityName: "Toronto",
    stateName: "Ontario",
    stateAbbreviation: "ON",
    countryName: "Canada",
    countryCode: "CA",
    countrySlug: "canada",
    regionSlug: "ontario",
    citySlug: "toronto-on-ca",
    lat: 43.6532,
    lng: -79.3832,
    supportedRadius: 30,
    dataCoverageScore: 98,
    businessCount: 1620,
    relevantCategoryCount: 35,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["mississauga-on-ca", "brampton-on-ca", "hamilton-on-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Greater Toronto Area (Financial District, Liberty Village, Yorkville, North York)",
      localContextText: "As Canada's largest commercial, financial, and technology hub, Toronto hosts thousands of independent professional firms, tech agencies, specialized health clinics, and boutique advisories.",
      majorDistricts: [
        { name: "Financial District & Bay Street Corridor", desc: "Corporate law firms, wealth management practices, accounting advisories, and fintech ventures." },
        { name: "Liberty Village & King West Tech Belt", desc: "Digital design studios, software startups, creative marketing agencies, and media companies." },
        { name: "Discovery District & University Health Network", desc: "Medical research practices, specialized outpatient care, clinical trial labs, and biotech startups." }
      ],
      topSectors: [
        { title: "Financial & Professional Legal Services", desc: "Boutique litigation firms, CPA practices, wealth advisories, and corporate consulting." },
        { title: "Health & Specialized Outpatient Medicine", desc: "Private medical practices, dental centers, physical rehabilitation hubs, and diagnostic facilities." },
        { title: "Software & Digital Innovation Agencies", desc: "Custom web development agencies, cloud consulting practices, and UX design studios." }
      ],
      majorInstitutions: ["University of Toronto", "Toronto Metropolitan University", "York University", "George Brown College"]
    }
  },
  {
    id: "ca-on-ottawa",
    cityName: "Ottawa",
    stateName: "Ontario",
    stateAbbreviation: "ON",
    countryName: "Canada",
    countryCode: "CA",
    countrySlug: "canada",
    regionSlug: "ontario",
    citySlug: "ottawa-on-ca",
    lat: 45.4215,
    lng: -75.6972,
    supportedRadius: 25,
    dataCoverageScore: 95,
    businessCount: 880,
    relevantCategoryCount: 28,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["gatineau-qc-ca", "kingston-on-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Ottawa-Gatineau Capital Region (Kanata North, Downtown, ByWard Market)",
      localContextText: "Canada's national capital pairs a dense government consulting ecosystem with Kanata North—Canada's largest technology park—creating extensive unadvertised hiring potential.",
      majorDistricts: [
        { name: "Kanata North Technology Park", desc: "Telecommunications firms, cybersecurity vendors, defense software contractors, and hardware labs." },
        { name: "Downtown Capital Core", desc: "Public policy advisories, government relations firms, law offices, and national trade associations." },
        { name: "Westboro & Wellington West", desc: "Design boutiques, specialized health practices, engineering consultants, and artisan services." }
      ],
      topSectors: [
        { title: "Technology & Telecom Engineering", desc: "Embedded software firms, network infrastructure groups, and enterprise cloud providers." },
        { title: "Public Affairs & Legal Services", desc: "Administrative law offices, regulatory compliance advisories, and policy consulting." },
        { title: "Outpatient Healthcare & Wellness", desc: "Private medical clinics, sports injury therapy practices, and dental offices." }
      ],
      majorInstitutions: ["University of Ottawa", "Carleton University", "Algonquin College"]
    }
  },
  {
    id: "ca-on-mississauga",
    cityName: "Mississauga",
    stateName: "Ontario",
    stateAbbreviation: "ON",
    countryName: "Canada",
    countryCode: "CA",
    countrySlug: "canada",
    regionSlug: "ontario",
    citySlug: "mississauga-on-ca",
    lat: 43.589,
    lng: -79.6441,
    supportedRadius: 20,
    dataCoverageScore: 94,
    businessCount: 920,
    relevantCategoryCount: 30,
    priority: 2,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["toronto-on-ca", "brampton-on-ca", "hamilton-on-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Mississauga City Centre & Meadowvale Corporate Hub",
      localContextText: "Home to Canada's largest concentration of Fortune 500 branch offices, logistics operators, pharmaceutical hubs, and precision trade contractors.",
      majorDistricts: [
        { name: "Meadowvale Corporate & Life Sciences Zone", desc: "Medical device manufacturers, pharmaceutical distributors, and technical service providers." },
        { name: "City Centre & Square One District", desc: "Accounting practices, real estate brokerages, financial consultancies, and marketing shops." },
        { name: "Airport Corporate Centre", desc: "Freight forwarding operators, supply chain specialists, and commercial service contractors." }
      ],
      topSectors: [
        { title: "Supply Chain & Technical Freight Logistics", desc: "Commercial freight brokers, cold storage logistics, and customs advisories." },
        { title: "Pharmaceuticals & Healthcare Equipment", desc: "Clinical research offices, medical equipment suppliers, and diagnostic labs." },
        { title: "Commercial Trade Construction", desc: "Electrical contractors, HVAC systems servicing, and industrial automation firms." }
      ],
      majorInstitutions: ["University of Toronto Mississauga (UTM)", "Sheridan College (Hazel McCallion Campus)"]
    }
  },
  {
    id: "ca-on-hamilton",
    cityName: "Hamilton",
    stateName: "Ontario",
    stateAbbreviation: "ON",
    countryName: "Canada",
    countryCode: "CA",
    countrySlug: "canada",
    regionSlug: "ontario",
    citySlug: "hamilton-on-ca",
    lat: 43.2557,
    lng: -79.8711,
    supportedRadius: 20,
    dataCoverageScore: 92,
    businessCount: 650,
    relevantCategoryCount: 26,
    priority: 2,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["mississauga-on-ca", "toronto-on-ca", "kitchener-on-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Hamilton Metropolitan Area & McMaster Innovation Park",
      localContextText: "Hamilton is transforming into a major healthcare research, advanced manufacturing, and green-technology powerhouse anchored by McMaster University.",
      majorDistricts: [
        { name: "McMaster Innovation Park & Health Sciences", desc: "Biotech incubators, medical devices labs, and specialized health practices." },
        { name: "Downtown Hamilton & James Street North", desc: "Architectural firms, creative studios, legal practices, and software agencies." },
        { name: "Bayfront Industrial & Port District", desc: "Advanced steel fabrication, heavy equipment services, and industrial engineering." }
      ],
      topSectors: [
        { title: "Health Sciences & Specialized Medicine", desc: "Outpatient clinical research, orthopedic therapy centers, and dental practices." },
        { title: "Advanced Manufacturing & Fabrication", desc: "Precision tooling shops, environmental engineering firms, and industrial contractors." },
        { title: "Creative Services & Web Engineering", desc: "Boutique advertising agencies, software consultancies, and digital production studios." }
      ],
      majorInstitutions: ["McMaster University", "Mohawk College"]
    }
  },
  {
    id: "ca-on-london",
    cityName: "London",
    stateName: "Ontario",
    stateAbbreviation: "ON",
    countryName: "Canada",
    countryCode: "CA",
    countrySlug: "canada",
    regionSlug: "ontario",
    citySlug: "london-on-ca",
    lat: 42.9849,
    lng: -81.2453,
    supportedRadius: 20,
    dataCoverageScore: 91,
    businessCount: 540,
    relevantCategoryCount: 24,
    priority: 2,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["kitchener-on-ca", "windsor-on-ca", "hamilton-on-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "London Metropolitan Area & Western Research Parks",
      localContextText: "Southwestern Ontario's regional educational and healthcare hub features active commercial hiring in insurance, medical technologies, and specialized manufacturing.",
      majorDistricts: [
        { name: "Downtown Core & Richmond Row", desc: "Law offices, financial planning advisories, accounting firms, and digital marketing shops." },
        { name: "Western Discovery Park", desc: "Agri-tech laboratories, medical device innovation centers, and green energy research." },
        { name: "Advanced Manufacturing & Logistics Belt", desc: "Automotive parts suppliers, industrial food processors, and freight contractors." }
      ],
      topSectors: [
        { title: "Medical Research & Clinical Healthcare", desc: "Private medical groups, rehabilitation clinics, and healthcare staffing agencies." },
        { title: "Financial & Insurance Services", desc: "Independent insurance brokers, wealth management groups, and accounting offices." },
        { title: "Agri-Food & Bio-Engineering", desc: "Agricultural technology vendors, food safety labs, and environmental engineering." }
      ],
      majorInstitutions: ["Western University (UWO)", "Fanshawe College"]
    }
  },
  {
    id: "ca-on-brampton",
    cityName: "Brampton",
    stateName: "Ontario",
    stateAbbreviation: "ON",
    countryName: "Canada",
    countryCode: "CA",
    countrySlug: "canada",
    regionSlug: "ontario",
    citySlug: "brampton-on-ca",
    lat: 43.7315,
    lng: -79.7624,
    supportedRadius: 20,
    dataCoverageScore: 92,
    businessCount: 710,
    relevantCategoryCount: 25,
    priority: 2,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["mississauga-on-ca", "toronto-on-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Brampton Innovation District & Logistics Hub",
      localContextText: "One of Canada's fastest-growing cities with dense concentration in advanced food processing, logistics, construction trades, and health tech.",
      majorDistricts: [
        { name: "Brampton Innovation District (Downtown)", desc: "Tech incubators, legal firms, accounting services, and entrepreneurship centers." },
        { name: "Steeles & Goreway Industrial Corridor", desc: "Automotive logistics, food manufacturing facilities, and heavy trade contractors." }
      ],
      topSectors: [
        { title: "Logistics & Freight Services", desc: "Distribution operators, commercial trucking fleets, and supply chain advisories." },
        { title: "Advanced Manufacturing & Construction Trades", desc: "Electrical, plumbing, HVAC, and metal fabrication workshops." }
      ],
      majorInstitutions: ["Algoma University at Brampton", "Sheridan College (Davis Campus)"]
    }
  },
  {
    id: "ca-on-windsor",
    cityName: "Windsor",
    stateName: "Ontario",
    stateAbbreviation: "ON",
    countryName: "Canada",
    countryCode: "CA",
    countrySlug: "canada",
    regionSlug: "ontario",
    citySlug: "windsor-on-ca",
    lat: 42.3149,
    lng: -83.0364,
    supportedRadius: 20,
    dataCoverageScore: 90,
    businessCount: 420,
    relevantCategoryCount: 22,
    priority: 2,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["london-on-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Windsor-Essex Automotive & EV Battery Tech Corridor",
      localContextText: "Canada's automotive capital is undergoing an electric vehicle manufacturing transformation, fueling growth in automation engineering and trade services.",
      majorDistricts: [
        { name: "EC Row & Industrial Parks", desc: "Tool and die shops, industrial robotics integrators, and automotive suppliers." },
        { name: "Downtown Windsor & Riverfront", desc: "Legal offices, customs brokerage advisories, and hospitality management." }
      ],
      topSectors: [
        { title: "Automotive & EV Battery Engineering", desc: "Industrial automation contractors, robotics technicians, and tooling specialists." },
        { title: "Cross-Border Logistics & Customs", desc: "International freight forwarders, customs consultancies, and trade services." }
      ],
      majorInstitutions: ["University of Windsor", "St. Clair College"]
    }
  },
  {
    id: "ca-on-kingston",
    cityName: "Kingston",
    stateName: "Ontario",
    stateAbbreviation: "ON",
    countryName: "Canada",
    countryCode: "CA",
    countrySlug: "canada",
    regionSlug: "ontario",
    citySlug: "kingston-on-ca",
    lat: 44.2312,
    lng: -76.486,
    supportedRadius: 20,
    dataCoverageScore: 89,
    businessCount: 310,
    relevantCategoryCount: 20,
    priority: 2,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["ottawa-on-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Kingston Health & Higher Education Corridor",
      localContextText: "Eastern Ontario's regional hub anchored by Queen's University and Kingston Health Sciences Centre, specializing in green materials and health innovation.",
      majorDistricts: [
        { name: "Downtown Kingston Historic Core", desc: "Law firms, accounting practices, heritage architecture studios, and boutique retail." },
        { name: "Innovation Park & Business Campus", desc: "Clean tech labs, materials engineering firms, and specialized software vendors." }
      ],
      topSectors: [
        { title: "Healthcare & Clinical Research", desc: "Outpatient medical groups, specialized therapy centers, and clinical trials." },
        { title: "Clean Tech & Advanced Materials", desc: "Environmental engineering advisories, renewable energy labs, and green tech." }
      ],
      majorInstitutions: ["Queen's University", "St. Lawrence College", "Royal Military College of Canada"]
    }
  },
  {
    id: "ca-on-kitchener",
    cityName: "Kitchener",
    stateName: "Ontario",
    stateAbbreviation: "ON",
    countryName: "Canada",
    countryCode: "CA",
    countrySlug: "canada",
    regionSlug: "ontario",
    citySlug: "kitchener-on-ca",
    lat: 43.4516,
    lng: -80.4925,
    supportedRadius: 15,
    dataCoverageScore: 93,
    businessCount: 520,
    relevantCategoryCount: 25,
    priority: 2,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["waterloo-on-ca", "hamilton-on-ca", "london-on-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Waterloo Region Tech & Manufacturing Hub",
      localContextText: "Part of Canada's Silicon Valley North, Kitchener combines repurposed historic brick industrial spaces with high-growth software, hardware, and design firms.",
      majorDistricts: [
        { name: "Downtown Kitchener & Innovation District", desc: "Software agencies, artificial intelligence startups, and design studios." },
        { name: "Huron Business Park", desc: "Advanced robotics labs, manufacturing automation, and industrial services." }
      ],
      topSectors: [
        { title: "Software Development & Enterprise AI", desc: "Boutique software engineering, SaaS consultancies, and cybersecurity advisories." },
        { title: "Automation & Mechanical Engineering", desc: "Robotics integrators, custom fabrication, and electrical services." }
      ],
      majorInstitutions: ["Conestoga College", "University of Waterloo (Downtown Health Sciences)"]
    }
  },
  {
    id: "ca-on-waterloo",
    cityName: "Waterloo",
    stateName: "Ontario",
    stateAbbreviation: "ON",
    countryName: "Canada",
    countryCode: "CA",
    countrySlug: "canada",
    regionSlug: "ontario",
    citySlug: "waterloo-on-ca",
    lat: 43.4643,
    lng: -80.5204,
    supportedRadius: 15,
    dataCoverageScore: 94,
    businessCount: 480,
    relevantCategoryCount: 24,
    priority: 2,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["kitchener-on-ca", "hamilton-on-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Waterloo Quantum & Technology Triangle",
      localContextText: "Global reputation for quantum computing, software engineering talent, and venture-backed technology startups.",
      majorDistricts: [
        { name: "UWaterloo R&D Park & Idea Quarter", desc: "Quantum tech labs, AI research firms, hardware incubators, and IP law practices." },
        { name: "Uptown Waterloo", desc: "Financial planning advisories, boutique law offices, and marketing agencies." }
      ],
      topSectors: [
        { title: "Technology & Software R&D", desc: "Deep-tech research labs, developer tooling, and enterprise cloud solutions." },
        { title: "Intellectual Property & Corporate Law", desc: "Tech-focused law practices, patent consultancies, and corporate compliance." }
      ],
      majorInstitutions: ["University of Waterloo", "Wilfrid Laurier University"]
    }
  },

  // BRITISH COLUMBIA
  {
    id: "ca-bc-vancouver",
    cityName: "Vancouver",
    stateName: "British Columbia",
    stateAbbreviation: "BC",
    countryName: "Canada",
    countryCode: "CA",
    countrySlug: "canada",
    regionSlug: "british-columbia",
    citySlug: "vancouver-bc-ca",
    lat: 49.2827,
    lng: -123.1207,
    supportedRadius: 25,
    dataCoverageScore: 97,
    businessCount: 1450,
    relevantCategoryCount: 34,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["burnaby-bc-ca", "richmond-bc-ca", "surrey-bc-ca", "victoria-bc-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Metro Vancouver (Downtown Core, Mount Pleasant Tech, Yaletown, Kitsilano)",
      localContextText: "Canada's Pacific gateway holds thriving industries in software technology, interactive media, environmental engineering, clean energy, and international trade.",
      majorDistricts: [
        { name: "Mount Pleasant Tech & Mount Pleasant Light Industrial", desc: "VFX studios, gaming developers, clean tech engineering, and digital marketing." },
        { name: "Downtown Financial & Trade Core", desc: "Maritime law practices, natural resources finance, real estate advisories, and accounting." },
        { name: "Broadway Tech & Health Corridor", desc: "Medical research clinics, outpatient specialized care, and biotech labs." }
      ],
      topSectors: [
        { title: "Software & Digital Media Production", desc: "Game design studios, animation production, web application development, and AI." },
        { title: "Clean Tech & Environmental Engineering", desc: "Renewable energy consultants, green building architecture, and environmental testing." },
        { title: "Private Healthcare & Specialized Medicine", desc: "Integrative clinics, outpatient surgical centers, and physical therapy practices." }
      ],
      majorInstitutions: ["University of British Columbia (UBC)", "Simon Fraser University (Vancouver)", "BCIT", "Emily Carr University"]
    }
  },
  {
    id: "ca-bc-victoria",
    cityName: "Victoria",
    stateName: "British Columbia",
    stateAbbreviation: "BC",
    countryName: "Canada",
    countryCode: "CA",
    countrySlug: "canada",
    regionSlug: "british-columbia",
    citySlug: "victoria-bc-ca",
    lat: 48.4284,
    lng: -123.3656,
    supportedRadius: 20,
    dataCoverageScore: 92,
    businessCount: 490,
    relevantCategoryCount: 22,
    priority: 2,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["vancouver-bc-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Greater Victoria Capital Region",
      localContextText: "British Columbia's capital pairs government operations with a bustling marine technology, ocean sciences, and specialized software ecosystem.",
      majorDistricts: [
        { name: "Downtown Victoria & Inner Harbour", desc: "Public sector law practices, legislative consultancies, software agencies, and tourism operations." },
        { name: "Marine & Technology Park (Sidney / Saanich)", desc: "Ocean science technology, marine defense suppliers, and environmental testing labs." }
      ],
      topSectors: [
        { title: "Ocean Technology & Environmental Science", desc: "Marine research tech, acoustics testing, and coastal engineering consultancies." },
        { title: "Legal & Administrative Services", desc: "Government relations advisories, administrative law offices, and environmental compliance." }
      ],
      majorInstitutions: ["University of Victoria (UVic)", "Camosun College", "Royal Roads University"]
    }
  },
  {
    id: "ca-bc-surrey",
    cityName: "Surrey",
    stateName: "British Columbia",
    stateAbbreviation: "BC",
    countryName: "Canada",
    countryCode: "CA",
    countrySlug: "canada",
    regionSlug: "british-columbia",
    citySlug: "surrey-bc-ca",
    lat: 49.1913,
    lng: -122.849,
    supportedRadius: 20,
    dataCoverageScore: 93,
    businessCount: 820,
    relevantCategoryCount: 26,
    priority: 2,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["vancouver-bc-ca", "burnaby-bc-ca", "richmond-bc-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Surrey City Centre & Campbell Heights Industrial Park",
      localContextText: "BC's fastest-growing municipality features massive health technology expansions and trade construction services.",
      majorDistricts: [
        { name: "Surrey Health & Technology District", desc: "Medical technology ventures, outpatient clinics, health research labs, and specialty practices." },
        { name: "Campbell Heights Clean Industrial Zone", desc: "Advanced manufacturing, cold storage logistics, construction trades, and clean tech." }
      ],
      topSectors: [
        { title: "Health Technology & Clinical Outpatient Medicine", desc: "Specialty clinics, prosthetics labs, physical rehabilitation, and medical software." },
        { title: "Commercial Construction Trades", desc: "Electrical, plumbing, HVAC, glazing, and general contracting firms." }
      ],
      majorInstitutions: ["Simon Fraser University (Surrey Campus)", "Kwantlen Polytechnic University (KPU)"]
    }
  },
  {
    id: "ca-bc-burnaby",
    cityName: "Burnaby",
    stateName: "British Columbia",
    stateAbbreviation: "BC",
    countryName: "Canada",
    countryCode: "CA",
    countrySlug: "canada",
    regionSlug: "british-columbia",
    citySlug: "burnaby-bc-ca",
    lat: 49.2488,
    lng: -122.9805,
    supportedRadius: 15,
    dataCoverageScore: 94,
    businessCount: 680,
    relevantCategoryCount: 25,
    priority: 2,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["vancouver-bc-ca", "surrey-bc-ca", "richmond-bc-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Burnaby Metrotown & Discovery Parks Corridor",
      localContextText: "Strategic center for film production studios, fuel cell clean tech, software development, and telecom research.",
      majorDistricts: [
        { name: "Discovery Place & Willingdon Tech Park", desc: "Clean energy fuel cell labs, software developers, and telecom engineering." },
        { name: "Metrotown & Brentwood Urban Hubs", desc: "Financial services, dental groups, real estate agencies, and marketing practices." }
      ],
      topSectors: [
        { title: "Clean Energy & Hydrogen Technology", desc: "Fuel cell engineering, clean tech R&D, and environmental systems." },
        { title: "Film Production & Digital Media", desc: "Sound stages, VFX studios, and post-production engineering." }
      ],
      majorInstitutions: ["Simon Fraser University (SFU Burnaby)", "British Columbia Institute of Technology (BCIT)"]
    }
  },
  {
    id: "ca-bc-richmond",
    cityName: "Richmond",
    stateName: "British Columbia",
    stateAbbreviation: "BC",
    countryName: "Canada",
    countryCode: "CA",
    countrySlug: "canada",
    regionSlug: "british-columbia",
    citySlug: "richmond-bc-ca",
    lat: 49.1666,
    lng: -123.1336,
    supportedRadius: 15,
    dataCoverageScore: 93,
    businessCount: 610,
    relevantCategoryCount: 24,
    priority: 2,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["vancouver-bc-ca", "burnaby-bc-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Richmond YVR Aviation & Trade Zone",
      localContextText: "Home to Vancouver International Airport, aviation servicing, international freight, trade logistics, and green agriculture.",
      majorDistricts: [
        { name: "YVR Aviation & Cargo Belt", desc: "Aviation maintenance, customs brokerage, supply chain logistics, and freight operations." },
        { name: "City Centre & No. 3 Road Corridor", desc: "Accounting practices, law firms, specialized medical clinics, and retail services." }
      ],
      topSectors: [
        { title: "Aviation & Freight Logistics", desc: "Air cargo operations, freight forwarding, and international customs compliance." },
        { title: "Specialized Food & Agriculture Processing", desc: "Commercial greenhouses, food safety laboratories, and processing plants." }
      ],
      majorInstitutions: ["Kwantlen Polytechnic University (Richmond)", "BCIT Aerospace Campus"]
    }
  },
  {
    id: "ca-bc-kelowna",
    cityName: "Kelowna",
    stateName: "British Columbia",
    stateAbbreviation: "BC",
    countryName: "Canada",
    countryCode: "CA",
    countrySlug: "canada",
    regionSlug: "british-columbia",
    citySlug: "kelowna-bc-ca",
    lat: 49.888,
    lng: -119.496,
    supportedRadius: 20,
    dataCoverageScore: 90,
    businessCount: 380,
    relevantCategoryCount: 21,
    priority: 2,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["vancouver-bc-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Okanagan Tech & Innovation Hub",
      localContextText: "The commercial heartbeat of the Okanagan Valley, featuring a booming tech startup sector, wine industry technology, and specialized healthcare.",
      majorDistricts: [
        { name: "Downtown Kelowna & Innovation Centre", desc: "Software agencies, mobile application developers, digital marketing, and design." },
        { name: "Kelowna Airport Business Park", desc: "Aerospace technology, light manufacturing, and logistics distribution." }
      ],
      topSectors: [
        { title: "Software & Digital Agencies", desc: "SaaS consultancies, web engineering, and digital marketing." },
        { title: "Viticulture & Agritech", desc: "Winery automation, agricultural sensors, and specialized irrigation technology." }
      ],
      majorInstitutions: ["University of British Columbia Okanagan (UBCO)", "Okanagan College"]
    }
  },

  // QUEBEC
  {
    id: "ca-qc-montreal",
    cityName: "Montréal",
    stateName: "Quebec",
    stateAbbreviation: "QC",
    countryName: "Canada",
    countryCode: "CA",
    countrySlug: "canada",
    regionSlug: "quebec",
    citySlug: "montreal-qc-ca",
    lat: 45.5017,
    lng: -73.5673,
    supportedRadius: 30,
    dataCoverageScore: 98,
    businessCount: 1580,
    relevantCategoryCount: 35,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["laval-qc-ca", "gatineau-qc-ca", "sherbrooke-qc-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Grand Montréal (Mile End Tech, Cité du Multimédia, Downtown Core, Laval)",
      localContextText: "A world-recognized capital for Artificial Intelligence research, aerospace engineering, video game development, and life sciences.",
      majorDistricts: [
        { name: "Mile Ex AI Corridor & Mile End", desc: "Deep learning research labs, AI startups, video game studios, and creative agencies." },
        { name: "Downtown Financial & Legal Core", desc: "Corporate law offices, accounting practices, civil engineering consultancies, and finance." },
        { name: "Technoparc Montréal & Aerospace Hub", desc: "Aircraft systems suppliers, avionics engineering, and biopharmaceutical research." }
      ],
      topSectors: [
        { title: "Artificial Intelligence & Video Game Development", desc: "AI consultancies, gaming production studios, and machine learning labs." },
        { title: "Aerospace & High-Precision Tech", desc: "Avionics software, composite material engineering, and aerospace testing." },
        { title: "Biopharmaceuticals & Medical Science", desc: "Private outpatient clinics, clinical trial labs, and diagnostic centers." }
      ],
      majorInstitutions: ["McGill University", "Université de Montréal (UdeM)", "Concordia University", "ÉTS Montréal", "HEC Montréal"]
    }
  },
  {
    id: "ca-qc-quebec-city",
    cityName: "Québec City",
    stateName: "Quebec",
    stateAbbreviation: "QC",
    countryName: "Canada",
    countryCode: "CA",
    countrySlug: "canada",
    regionSlug: "quebec",
    citySlug: "quebec-city-qc-ca",
    lat: 46.8139,
    lng: -71.208,
    supportedRadius: 25,
    dataCoverageScore: 94,
    businessCount: 780,
    relevantCategoryCount: 27,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["montreal-qc-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Québec City Metropolitan Area & Parc Technologique",
      localContextText: "Quebec's provincial capital blends administrative, legal, optics/photonics engineering, and insurance corporate headquarters.",
      majorDistricts: [
        { name: "Parc Technologique du Québec Métropolitain", desc: "Optics and photonics research, geospatial software, and environmental labs." },
        { name: "Colline Parlementaire & Saint-Roch", desc: "Government relations consultancies, law practices, software studios, and marketing." }
      ],
      topSectors: [
        { title: "Optics, Photonics & Laser Systems", desc: "Specialized optical engineering, sensor technologies, and defense contractors." },
        { title: "Insurance & Financial Advisories", desc: "Mutual insurance headquarters, claims advisories, and accounting practices." }
      ],
      majorInstitutions: ["Université Laval", "Cégep de Sainte-Foy"]
    }
  },
  {
    id: "ca-qc-laval",
    cityName: "Laval",
    stateName: "Quebec",
    stateAbbreviation: "QC",
    countryName: "Canada",
    countryCode: "CA",
    countrySlug: "canada",
    regionSlug: "quebec",
    citySlug: "laval-qc-ca",
    lat: 45.5699,
    lng: -73.692,
    supportedRadius: 20,
    dataCoverageScore: 92,
    businessCount: 520,
    relevantCategoryCount: 23,
    priority: 2,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["montreal-qc-ca", "gatineau-qc-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Laval Biotech Science Park & Industrial Zone",
      localContextText: "Renowned for Cité de la Santé medical research, biotechnology labs, logistics, and specialized trade contracting.",
      majorDistricts: [
        { name: "Cité de la Santé & Biotech Park", desc: "Clinical trials, pharmaceutical laboratories, and outpatient specialty medicine." },
        { name: "Autoroute 13 Industrial Zone", desc: "Commercial HVAC contractors, metal fabrication, and distribution hubs." }
      ],
      topSectors: [
        { title: "Biotechnology & Life Sciences", desc: "Lab testing, medical research, and pharmaceutical packaging." },
        { title: "Commercial Construction & Mechanical Trades", desc: "Electrical contractors, plumbing supply, and industrial maintenance." }
      ],
      majorInstitutions: ["INRS Armand-Frappier Centre", "Collège Montmorency"]
    }
  },
  {
    id: "ca-qc-gatineau",
    cityName: "Gatineau",
    stateName: "Quebec",
    stateAbbreviation: "QC",
    countryName: "Canada",
    countryCode: "CA",
    countrySlug: "canada",
    regionSlug: "quebec",
    citySlug: "gatineau-qc-ca",
    lat: 45.4765,
    lng: -75.7013,
    supportedRadius: 20,
    dataCoverageScore: 90,
    businessCount: 410,
    relevantCategoryCount: 21,
    priority: 2,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["ottawa-on-ca", "montreal-qc-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Gatineau Capital Region & Place du Portage",
      localContextText: "Directly facing Ottawa across the Ottawa River, Gatineau connects federal administrative services with local healthcare and regional commercial trades.",
      majorDistricts: [
        { name: "Hull Sector & Place du Portage", desc: "Public administration, legal consulting, translation agencies, and IT support." },
        { name: "Gatineau Commercial & Trade Sector", desc: "Residential construction contractors, auto services, and retail operations." }
      ],
      topSectors: [
        { title: "Translation & Administrative Consulting", desc: "Language advisories, compliance consultancies, and IT management." },
        { title: "Building Trades & Infrastructure", desc: "Masonry, roofing, electrical contracting, and civil engineering." }
      ],
      majorInstitutions: ["Université du Québec en Outaouais (UQO)", "Cégep de l'Outaouais"]
    }
  },
  {
    id: "ca-qc-sherbrooke",
    cityName: "Sherbrooke",
    stateName: "Quebec",
    stateAbbreviation: "QC",
    countryName: "Canada",
    countryCode: "CA",
    countrySlug: "canada",
    regionSlug: "quebec",
    citySlug: "sherbrooke-qc-ca",
    lat: 45.4042,
    lng: -71.8929,
    supportedRadius: 20,
    dataCoverageScore: 89,
    businessCount: 340,
    relevantCategoryCount: 20,
    priority: 2,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["montreal-qc-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Sherbrooke Quantum & Academic Innovation Hub",
      localContextText: "A primary university town in the Eastern Townships specializing in quantum science research, microelectronics, and clean technology.",
      majorDistricts: [
        { name: "Sherbrooke Innovation District & Espace LAB412", desc: "Quantum tech incubators, microelectronics labs, and specialized software development." },
        { name: "Downtown Sherbrooke Commerce", desc: "Legal offices, local accounting, marketing consultancies, and health clinics." }
      ],
      topSectors: [
        { title: "Microelectronics & Quantum Innovation", desc: "Semiconductor research labs, quantum software, and technical design." },
        { title: "Regional Healthcare & University Medicine", desc: "Specialty outpatient clinics, rehabilitation, and dental centers." }
      ],
      majorInstitutions: ["Université de Sherbrooke", "Bishop's University", "Cégep de Sherbrooke"]
    }
  },

  // ALBERTA
  {
    id: "ca-ab-calgary",
    cityName: "Calgary",
    stateName: "Alberta",
    stateAbbreviation: "AB",
    countryName: "Canada",
    countryCode: "CA",
    countrySlug: "canada",
    regionSlug: "alberta",
    citySlug: "calgary-ab-ca",
    lat: 51.0447,
    lng: -114.0719,
    supportedRadius: 30,
    dataCoverageScore: 97,
    businessCount: 1380,
    relevantCategoryCount: 33,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["edmonton-ab-ca", "red-deer-ab-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Calgary Metropolitan Area (Downtown Commercial, Beltline Tech, Foothills Industrial)",
      localContextText: "Western Canada's corporate capital is rapidly expanding beyond traditional energy into clean technology, financial services, logistics, software, and health innovation.",
      majorDistricts: [
        { name: "Downtown Commercial Tower District", desc: "Corporate law firms, energy consultancies, financial brokerages, and accounting practices." },
        { name: "Beltline & Victoria Park Innovation Zone", desc: "Software engineering shops, fintech consultancies, marketing agencies, and design." },
        { name: "Foothills & Meridian Industrial Parks", desc: "Industrial equipment suppliers, heavy trade contractors, and logistics hubs." }
      ],
      topSectors: [
        { title: "Clean Energy Technology & Engineering", desc: "Environmental engineering, carbon capture software, and technical consultancies." },
        { title: "Corporate Legal & Financial Services", desc: "Boutique law practices, tax accounting firms, and commercial finance." },
        { title: "Heavy Commercial Trade Contracting", desc: "Electrical contractors, welding, pipeline servicing, and mechanical trades." }
      ],
      majorInstitutions: ["University of Calgary", "Mount Royal University", "SAIT (Southern Alberta Institute of Technology)"]
    }
  },
  {
    id: "ca-ab-edmonton",
    cityName: "Edmonton",
    stateName: "Alberta",
    stateAbbreviation: "AB",
    countryName: "Canada",
    countryCode: "CA",
    countrySlug: "canada",
    regionSlug: "alberta",
    citySlug: "edmonton-ab-ca",
    lat: 53.5461,
    lng: -113.4938,
    supportedRadius: 30,
    dataCoverageScore: 96,
    businessCount: 1220,
    relevantCategoryCount: 31,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["calgary-ab-ca", "red-deer-ab-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Greater Edmonton Capital Region (ICE District, Strathcona, Nisku Industrial)",
      localContextText: "Alberta's provincial capital leads in artificial intelligence research (Amii), health science innovation, government operations, and industrial manufacturing.",
      majorDistricts: [
        { name: "Downtown ICE District & Financial Core", desc: "Law offices, government consultancies, software firms, and corporate finance." },
        { name: "University & Strathcona Innovation Zone", desc: "AI research labs, medical device development, and creative agencies." },
        { name: "Acheson & Nisku Industrial Belt", desc: "Modular construction, heavy equipment repair, supply chain, and trade contractors." }
      ],
      topSectors: [
        { title: "Artificial Intelligence & Software Labs", desc: "Applied AI consulting, machine learning engineering, and enterprise software." },
        { title: "Medical Research & Diagnostic Care", desc: "Outpatient clinical research, orthopedic clinics, and specialized dental." },
        { title: "Industrial Trades & Fabrication", desc: "Heavy mechanical engineering, electrical services, and metal fabrication." }
      ],
      majorInstitutions: ["University of Alberta", "MacEwan University", "NAIT (Northern Alberta Institute of Technology)"]
    }
  },
  {
    id: "ca-ab-red-deer",
    cityName: "Red Deer",
    stateName: "Alberta",
    stateAbbreviation: "AB",
    countryName: "Canada",
    countryCode: "CA",
    countrySlug: "canada",
    regionSlug: "alberta",
    citySlug: "red-deer-ab-ca",
    lat: 52.2681,
    lng: -113.8112,
    supportedRadius: 20,
    dataCoverageScore: 88,
    businessCount: 290,
    relevantCategoryCount: 18,
    priority: 2,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["calgary-ab-ca", "edmonton-ab-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Red Deer Central Alberta Logistics & Trade Hub",
      localContextText: "Positioned midway between Calgary and Edmonton, Red Deer is the primary retail, medical, and trade distribution node for Central Alberta.",
      majorDistricts: [
        { name: "Downtown Red Deer Commerce", desc: "Local law practices, accounting services, real estate advisories, and dental offices." },
        { name: "Edgar Industrial & Queens Business Park", desc: "Equipment servicing, agricultural transport, and trade contracting." }
      ],
      topSectors: [
        { title: "Equipment Servicing & Commercial Trades", desc: "HVAC contracting, electrical maintenance, and heavy machinery repair." },
        { title: "Agricultural Transport & Distribution", desc: "Freight forwarding, grain handling technology, and supply logistics." }
      ],
      majorInstitutions: ["Red Deer Polytechnic"]
    }
  },
  {
    id: "ca-ab-lethbridge",
    cityName: "Lethbridge",
    stateName: "Alberta",
    stateAbbreviation: "AB",
    countryName: "Canada",
    countryCode: "CA",
    countrySlug: "canada",
    regionSlug: "alberta",
    citySlug: "lethbridge-ab-ca",
    lat: 49.6935,
    lng: -112.8418,
    supportedRadius: 20,
    dataCoverageScore: 88,
    businessCount: 270,
    relevantCategoryCount: 18,
    priority: 2,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["calgary-ab-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Lethbridge Agri-Food & Regional Medical Centre",
      localContextText: "Southern Alberta's economic hub focusing on commercial agri-food processing, agricultural technology, and regional healthcare.",
      majorDistricts: [
        { name: "Sherring Industrial Park", desc: "Agri-food research labs, food processing facilities, and distribution hubs." },
        { name: "Downtown Lethbridge Commercial Core", desc: "Law offices, veterinary consultancies, accounting practices, and financial advisories." }
      ],
      topSectors: [
        { title: "Agri-Food Processing & Biotechnology", desc: "Food technology research, agricultural diagnostics, and crop science." },
        { title: "Regional Healthcare & Dental Medicine", desc: "Outpatient clinics, physical therapy centers, and dental practices." }
      ],
      majorInstitutions: ["University of Lethbridge", "Lethbridge College"]
    }
  },

  // MANITOBA
  {
    id: "ca-mb-winnipeg",
    cityName: "Winnipeg",
    stateName: "Manitoba",
    stateAbbreviation: "MB",
    countryName: "Canada",
    countryCode: "CA",
    countrySlug: "canada",
    regionSlug: "manitoba",
    citySlug: "winnipeg-mb-ca",
    lat: 49.8951,
    lng: -97.1384,
    supportedRadius: 25,
    dataCoverageScore: 95,
    businessCount: 920,
    relevantCategoryCount: 29,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["saskatoon-sk-ca", "regina-sk-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Winnipeg Metropolitan Area (The Forks, Exchange District, CentrePort)",
      localContextText: "North America's largest tri-modal inland port (CentrePort) connects a heavy aerospace, agricultural technology, manufacturing, and financial services hub.",
      majorDistricts: [
        { name: "Exchange District Innovation Zone", desc: "Software agencies, design boutiques, architecture firms, and media studios." },
        { name: "CentrePort Canada Industrial Zone", desc: "Aerospace manufacturing, cold storage transport, and heavy equipment logistics." },
        { name: "Downtown Financial & Legal Quarter", desc: "Corporate insurance advisories, law offices, and accounting services." }
      ],
      topSectors: [
        { title: "Aerospace & Precision Manufacturing", desc: "Composite aircraft components, bus manufacturing, and heavy machining." },
        { title: "Agribusiness & Food Science Technology", desc: "Grain research labs, food technology innovation, and supply chain logistics." },
        { title: "Insurance & Financial Brokerages", desc: "Independent insurance advisories, wealth management, and accounting." }
      ],
      majorInstitutions: ["University of Manitoba", "The University of Winnipeg", "Red River College Polytechnic"]
    }
  },

  // SASKATCHEWAN
  {
    id: "ca-sk-saskatoon",
    cityName: "Saskatoon",
    stateName: "Saskatchewan",
    stateAbbreviation: "SK",
    countryName: "Canada",
    countryCode: "CA",
    countrySlug: "canada",
    regionSlug: "saskatchewan",
    citySlug: "saskatoon-sk-ca",
    lat: 52.1332,
    lng: -106.67,
    supportedRadius: 25,
    dataCoverageScore: 92,
    businessCount: 510,
    relevantCategoryCount: 23,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["regina-sk-ca", "winnipeg-mb-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Saskatoon & Innovation Place Research Park",
      localContextText: "Saskatchewan's largest city is a global leader in agricultural biotechnology, mining technology, nuclear research, and vaccine development.",
      majorDistricts: [
        { name: "Innovation Place Research Park", desc: "Ag-tech laboratories, vaccine development labs, software research, and environmental testing." },
        { name: "Downtown Saskatoon Core", desc: "Law offices, mining consultancies, accounting practices, and commercial finance." }
      ],
      topSectors: [
        { title: "Agricultural Biotechnology & Plant Genetics", desc: "Crop genetics research, soil testing labs, and agritech software." },
        { title: "Mining Technology & Engineering", desc: "Potash engineering consultancies, industrial electrical, and heavy servicing." }
      ],
      majorInstitutions: ["University of Saskatchewan (USask)", "Saskatchewan Polytechnic"]
    }
  },
  {
    id: "ca-sk-regina",
    cityName: "Regina",
    stateName: "Saskatchewan",
    stateAbbreviation: "SK",
    countryName: "Canada",
    countryCode: "CA",
    countrySlug: "canada",
    regionSlug: "saskatchewan",
    citySlug: "regina-sk-ca",
    lat: 50.4452,
    lng: -104.6189,
    supportedRadius: 20,
    dataCoverageScore: 91,
    businessCount: 440,
    relevantCategoryCount: 21,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["saskatoon-sk-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Regina Capital Region & Ross Industrial Park",
      localContextText: "Saskatchewan's provincial capital houses major government insurance operations, steel manufacturing, and agricultural equipment engineering.",
      majorDistricts: [
        { name: "Downtown Capital Quarter", desc: "Government relations firms, law practices, insurance advisories, and accounting." },
        { name: "Ross Industrial Park", desc: "Steel pipe fabrication, agricultural equipment repair, and trade contracting." }
      ],
      topSectors: [
        { title: "Financial & Crown Insurance Services", desc: "Insurance claims consultancies, financial advisories, and risk management." },
        { title: "Steel Fabrication & Heavy Trades", desc: "Electrical contracting, mechanical engineering, and welding services." }
      ],
      majorInstitutions: ["University of Regina", "Saskatchewan Polytechnic (Regina Campus)"]
    }
  },

  // NOVA SCOTIA
  {
    id: "ca-ns-halifax",
    cityName: "Halifax",
    stateName: "Nova Scotia",
    stateAbbreviation: "NS",
    countryName: "Canada",
    countryCode: "CA",
    countrySlug: "canada",
    regionSlug: "nova-scotia",
    citySlug: "halifax-ns-ca",
    lat: 44.6488,
    lng: -63.5752,
    supportedRadius: 25,
    dataCoverageScore: 94,
    businessCount: 680,
    relevantCategoryCount: 26,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["moncton-nb-ca", "fredericton-nb-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Halifax Regional Municipality (Downtown Waterfront, Burnside, Dartmouth)",
      localContextText: "Atlantic Canada's primary financial, naval defense, ocean technology, healthcare, and higher education powerhouse.",
      majorDistricts: [
        { name: "Halifax Waterfront & Financial Core", desc: "Maritime law firms, naval defense consultancies, corporate finance, and ocean tech." },
        { name: "Burnside Industrial Park (Dartmouth)", desc: "Heavy trade contracting, marine supply, logistics, and oceanographic testing." }
      ],
      topSectors: [
        { title: "Ocean Technology & Marine Defense", desc: "Sonar technology, oceanographic software, naval architecture, and marine engineering." },
        { title: "Healthcare Sciences & Specialized Medicine", desc: "Outpatient clinical research, orthopedic clinics, and dental care." }
      ],
      majorInstitutions: ["Dalhousie University", "Saint Mary's University", "NSCC (Nova Scotia Community College)"]
    }
  },

  // NEW BRUNSWICK
  {
    id: "ca-nb-moncton",
    cityName: "Moncton",
    stateName: "New Brunswick",
    stateAbbreviation: "NB",
    countryName: "Canada",
    countryCode: "CA",
    countrySlug: "canada",
    regionSlug: "new-brunswick",
    citySlug: "moncton-nb-ca",
    lat: 46.0878,
    lng: -64.7782,
    supportedRadius: 20,
    dataCoverageScore: 90,
    businessCount: 380,
    relevantCategoryCount: 20,
    priority: 2,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["fredericton-nb-ca", "halifax-ns-ca", "charlottetown-pe-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Greater Moncton Transportation & Tech Hub",
      localContextText: "Atlantic Canada's central logistics, distribution, multi-lingual customer experience, and software development center.",
      majorDistricts: [
        { name: "Downtown Moncton Commercial District", desc: "Bilingual law offices, accounting consultancies, insurance advisories, and IT support." },
        { name: "Moncton Industrial & Logistics Parks", desc: "Freight transport fleets, cold storage facilities, and trade services." }
      ],
      topSectors: [
        { title: "Transportation & Freight Logistics", desc: "Commercial freight forwarding, fleet maintenance, and supply chain." },
        { title: "Bilingual Corporate & Tech Services", desc: "IT helpdesk consultancies, software support, and legal services." }
      ],
      majorInstitutions: ["Université de Moncton", "NBCC (New Brunswick Community College)"]
    }
  },
  {
    id: "ca-nb-fredericton",
    cityName: "Fredericton",
    stateName: "New Brunswick",
    stateAbbreviation: "NB",
    countryName: "Canada",
    countryCode: "CA",
    countrySlug: "canada",
    regionSlug: "new-brunswick",
    citySlug: "fredericton-nb-ca",
    lat: 45.9636,
    lng: -66.6431,
    supportedRadius: 20,
    dataCoverageScore: 89,
    businessCount: 310,
    relevantCategoryCount: 19,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["moncton-nb-ca", "halifax-ns-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Fredericton Cybersecurity & Capital Innovation Hub",
      localContextText: "New Brunswick's provincial capital leads Canada in critical infrastructure cybersecurity, environmental science, and public administration.",
      majorDistricts: [
        { name: "Knowledge Park Cybersecurity Hub", desc: "Cybersecurity software labs, threat intelligence firms, and software consultancies." },
        { name: "Downtown Fredericton Capital Core", desc: "Administrative law offices, legislative consultancies, and accounting practices." }
      ],
      topSectors: [
        { title: "Cybersecurity & Software Innovation", desc: "Security architecture advisories, software engineering, and cloud security." },
        { title: "Public Policy & Environmental Science", desc: "Forestry engineering consultancies, environmental testing, and legal services." }
      ],
      majorInstitutions: ["University of New Brunswick (UNB)", "St. Thomas University"]
    }
  },

  // NEWFOUNDLAND AND LABRADOR
  {
    id: "ca-nl-st-johns",
    cityName: "St. John's",
    stateName: "Newfoundland and Labrador",
    stateAbbreviation: "NL",
    countryName: "Canada",
    countryCode: "CA",
    countrySlug: "canada",
    regionSlug: "newfoundland-and-labrador",
    citySlug: "st-johns-nl-ca",
    lat: 47.5615,
    lng: -52.7126,
    supportedRadius: 25,
    dataCoverageScore: 91,
    businessCount: 420,
    relevantCategoryCount: 22,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["halifax-ns-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "St. John's Ocean & Offshore Energy Center",
      localContextText: "Canada's easternmost city excels in ocean technology, offshore energy engineering, marine biology research, and specialized health sciences.",
      majorDistricts: [
        { name: "Downtown Harbour & Water Street Core", desc: "Admiralty law practices, marine insurance, ocean software, and creative boutiques." },
        { name: "Foxtrap & Donovans Industrial Parks", desc: "Marine equipment servicing, offshore drilling supplies, and industrial trades." }
      ],
      topSectors: [
        { title: "Ocean Engineering & Marine Tech", desc: "Subsea robotics testing, ocean mapping technology, and marine safety labs." },
        { title: "Offshore Servicing & Trade Contracting", desc: "Electrical, mechanical engineering, and heavy machinery servicing." }
      ],
      majorInstitutions: ["Memorial University of Newfoundland (MUN)", "College of the North Atlantic (CNA)"]
    }
  },

  // PRINCE EDWARD ISLAND
  {
    id: "ca-pe-charlottetown",
    cityName: "Charlottetown",
    stateName: "Prince Edward Island",
    stateAbbreviation: "PE",
    countryName: "Canada",
    countryCode: "CA",
    countrySlug: "canada",
    regionSlug: "prince-edward-island",
    citySlug: "charlottetown-pe-ca",
    lat: 46.2382,
    lng: -63.1311,
    supportedRadius: 15,
    dataCoverageScore: 88,
    businessCount: 220,
    relevantCategoryCount: 17,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["moncton-nb-ca", "halifax-ns-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Charlottetown Bioscience & Capital Hub",
      localContextText: "PEI's capital features a world-renowned bioscience cluster specializing in natural health products, animal health, and software engineering.",
      majorDistricts: [
        { name: "PEI BioCommons Park", desc: "Veterinary pharmaceutical research, natural bioactive extraction, and lab diagnostics." },
        { name: "Historic Downtown Charlottetown", desc: "Law offices, accounting firms, architecture studios, and artisan retail." }
      ],
      topSectors: [
        { title: "Bioscience & Veterinary Health", desc: "Animal health research labs, bioactive manufacturing, and clinical science." },
        { title: "Software & Digital Services", desc: "Custom web applications, digital marketing, and IT consultancies." }
      ],
      majorInstitutions: ["University of Prince Edward Island (UPEI)", "Holland College"]
    }
  },

  // TERRITORIES
  {
    id: "ca-yt-whitehorse",
    cityName: "Whitehorse",
    stateName: "Yukon",
    stateAbbreviation: "YT",
    countryName: "Canada",
    countryCode: "CA",
    countrySlug: "canada",
    regionSlug: "yukon",
    citySlug: "whitehorse-yt-ca",
    lat: 60.7212,
    lng: -135.0568,
    supportedRadius: 15,
    dataCoverageScore: 85,
    businessCount: 160,
    relevantCategoryCount: 15,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["vancouver-bc-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Whitehorse Northern Commerce & Mining Hub",
      localContextText: "Yukon's territorial capital is the commercial, environmental science, and mining support gateway for northern Canada.",
      majorDistricts: [
        { name: "Main Street & Downtown Commercial District", desc: "Indigenous law advisories, environmental engineering, accounting, and government affairs." },
        { name: "Marwell Industrial Sector", desc: "Cold-climate construction contracting, heavy equipment servicing, and aviation support." }
      ],
      topSectors: [
        { title: "Environmental Science & Mining Engineering", desc: "Geological survey consultancies, cold-climate building tech, and environmental impact testing." },
        { title: "Commercial Construction & Northern Logistics", desc: "HVAC contractors, insulation specialists, and air cargo transport." }
      ],
      majorInstitutions: ["Yukon University"]
    }
  },
  {
    id: "ca-nt-yellowknife",
    cityName: "Yellowknife",
    stateName: "Northwest Territories",
    stateAbbreviation: "NT",
    countryName: "Canada",
    countryCode: "CA",
    countrySlug: "canada",
    regionSlug: "northwest-territories",
    citySlug: "yellowknife-nt-ca",
    lat: 62.454,
    lng: -114.3718,
    supportedRadius: 15,
    dataCoverageScore: 85,
    businessCount: 150,
    relevantCategoryCount: 14,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["edmonton-ab-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Yellowknife NWT Capital & Aviation Hub",
      localContextText: "Administrative, logistical, and diamond mining servicing center for the Northwest Territories.",
      majorDistricts: [
        { name: "Downtown Yellowknife Core", desc: "Aboriginal law offices, public policy advisories, accounting practices, and healthcare clinics." },
        { name: "Kam Lake Industrial Park", desc: "Aviation maintenance, heavy transport fleets, and northern building contractors." }
      ],
      topSectors: [
        { title: "Northern Aviation & Logistics", desc: "Bush flying charters, air cargo transport, and cold-weather mechanical servicing." },
        { title: "Public Administration & Environmental Law", desc: "Land claims advisories, regulatory consultancies, and legal offices." }
      ],
      majorInstitutions: ["Aurora College"]
    }
  },
  {
    id: "ca-nu-iqaluit",
    cityName: "Iqaluit",
    stateName: "Nunavut",
    stateAbbreviation: "NU",
    countryName: "Canada",
    countryCode: "CA",
    countrySlug: "canada",
    regionSlug: "nunavut",
    citySlug: "iqaluit-nu-ca",
    lat: 63.7467,
    lng: -68.517,
    supportedRadius: 15,
    dataCoverageScore: 85,
    businessCount: 120,
    relevantCategoryCount: 12,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["ottawa-on-ca"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Iqaluit Capital & Arctic Commerce Hub",
      localContextText: "Capital of Nunavut, serving as the northern hub for Inuit governance, Arctic telecommunications, health services, and environmental science.",
      majorDistricts: [
        { name: "Iqaluit Capital & Federal Building Core", desc: "Territorial law consultancies, translation agencies, administrative offices, and community health." },
        { name: "Airport & Cargo Logistics Belt", desc: "Arctic freight handlers, heavy satellite communications support, and building trades." }
      ],
      topSectors: [
        { title: "Arctic Telecommunications & IT Support", desc: "Satellite internet consultancies, remote IT maintenance, and communications infrastructure." },
        { title: "Community Healthcare & Specialized Services", desc: "Outpatient clinical services, dental care, and public health support." }
      ],
      majorInstitutions: ["Nunavut Arctic College"]
    }
  }
];
